import Model  from '@/util/models';
import Kecamatan from './Kecamatan';

export default class Kelurahan extends Model { 
    backend = '/frc/kelurahan/'; 
    
    getKecamatan(){       
        let kecamatan = new Kecamatan;
        return kecamatan.all();        
    }  
}

